var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalcFigureAreaTriangleSas(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 250 250",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "Artboard1",
    x: 0,
    y: 0,
    width: 250,
    height: 250,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Artboard11"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.16201,0,0,1,-39.0503,-24.3673)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.071,115.77C125.071,123.7 131.499,130.128 139.428,130.128C147.358,130.128 153.786,123.7 153.786,115.77C153.786,123.7 147.358,130.128 139.428,130.128C131.499,130.128 125.071,123.7 125.071,115.77Z",
    style: {
      fill: "rgb(235,235,235)",
      stroke: "black",
      strokeWidth: "1.84px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-16.5505,-19.2391)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.517,77.274L213.869,225.978L65.165,225.978L139.517,77.274Z",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: 3
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.515765,0.977103,-0.21742,-0.114766,143.494,48.4854)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.836,106.4L24.836,121.324L15.98,101.425L24.836,81.527L24.836,96.451L158.576,96.451L158.576,81.527L167.431,101.425L158.576,121.324L158.576,106.4L24.836,106.4Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.531844,0.968446,-0.215494,0.118343,144.103,24.9807)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.836,106.4L24.836,121.324L15.98,101.425L24.836,81.527L24.836,96.451L158.576,96.451L158.576,81.527L167.431,101.425L158.576,121.324L158.576,106.4L24.836,106.4Z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.967528,0,0,0.967528,-21.6721,82.6865)"
  }, /*#__PURE__*/React.createElement("text", {
    x: "78.3px",
    y: "36.332px",
    style: {
      fontFamily: "'AndaleMono', 'Andale Mono', monospace",
      fontSize: "18.119px"
    }
  }, "x")), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.967528,0,0,0.967528,36.7063,62.2895)"
  }, /*#__PURE__*/React.createElement("text", {
    x: "78.3px",
    y: "36.332px",
    style: {
      fontFamily: "'AndaleMono', 'Andale Mono', monospace",
      fontSize: "18.119px"
    }
  }, "xy")), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.967528,0,0,0.967528,106.648,82.6865)"
  }, /*#__PURE__*/React.createElement("text", {
    x: "78.3px",
    y: "36.332px",
    style: {
      fontFamily: "'AndaleMono', 'Andale Mono', monospace",
      fontSize: "18.119px"
    }
  }, "y")), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.967528,0,0,0.967528,41.8081,102.276)"
  }, /*#__PURE__*/React.createElement("text", {
    x: "78.3px",
    y: "36.332px",
    style: {
      fontFamily: "'AndaleMono', 'Andale Mono', monospace",
      fontSize: "18.119px"
    }
  }, "A"))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalcFigureAreaTriangleSas);
export default __webpack_public_path__ + "static/media/calc-figure-area-triangleSAS.243f875dc3d3f9182381167a8ee65429.svg";
export { ForwardRef as ReactComponent };